import { EventEndType, ExamDay, type RecurringExamEventCreationFormType } from '../../providers';

const monthsThai = [
  'ม.ค.',
  'ก.พ.',
  'มี.ค.',
  'เม.ย.',
  'พ.ค.',
  'มิ.ย.',
  'ก.ค.',
  'ส.ค.',
  'ก.ย.',
  'ต.ค.',
  'พ.ย.',
  'ธ.ค.',
];

export function formatThaiDateTime(date: Date): string {
  const day = date.getDate();
  const month = monthsThai[date.getMonth()];
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  return `${day} ${month} ${year}, ${hours}:${minutes} น.`;
}

function formatThaiDateRangeSameMonth(
  start: Date,
  end: Date,
  timeStart: Date,
  timeEnd: Date,
): string {
  const dayStart = start.getDate();
  const dayEnd = end.getDate();
  const month = monthsThai[start.getMonth()];
  const year = start.getFullYear();

  const formattedStartTime =
    timeStart.getHours().toString().padStart(2, '0') +
    ':' +
    timeStart.getMinutes().toString().padStart(2, '0');
  const formattedEndTime =
    timeEnd.getHours().toString().padStart(2, '0') +
    ':' +
    timeEnd.getMinutes().toString().padStart(2, '0');

  return `วันที่ ${dayStart}-${dayEnd} ${month} ${year}, ${formattedStartTime} - ${formattedEndTime} น.`;
}
export function formatExamEndTime(
  eventEndDate?:
    | {
        type?: EventEndType | null | undefined;
        date?: number | null | undefined;
      }
    | undefined,
): string {
  if (!eventEndDate) return '-';
  if (eventEndDate.type === EventEndType.ON_EXAM_DATE) {
    return 'ปิดรับสมัคร: ปิดรับสมัครวันสอบ (ระบบจะปิดรับสมัครอัตโนมัติ 30 นาทีก่อนเวลาเริ่มสอบ)';
  }
  if (eventEndDate.type === EventEndType.BEFORE_EXAM_DATE && eventEndDate.date) {
    return `ปิดรับสมัคร: ปิดรับสมัครล่วงหน้า ${eventEndDate.date} วัน (เวลาปิดรับสมัคร: 23:59 น.)`;
  }
  return '-';
}

const examDayThaiLabelMap: Record<ExamDay, string> = {
  [ExamDay.MON]: 'จันทร์',
  [ExamDay.TUE]: 'อังคาร',
  [ExamDay.WED]: 'พุธ',
  [ExamDay.THU]: 'พฤหัสบดี',
  [ExamDay.FRI]: 'ศุกร์',
  [ExamDay.SAT]: 'เสาร์',
  [ExamDay.SUN]: 'อาทิตย์',
};

export function mapExamDaysToThai(days: ExamDay[]): string {
  if (!days || days.length === 0) return '-';
  return days.map((day) => examDayThaiLabelMap[day]).join(', ');
}

function getBuildingDisplayName(
  buildings: {
    buildingName: string;
    roomNumber: string;
    floor: string;
    roomNameTh: string;
    seat: number;
  }[],
): string[] {
  return buildings.map(
    (b) =>
      `อาคาร: ${b.buildingName} ชั้น: ${b.floor} ห้อง: ${b.roomNameTh} เลขห้อง: ${b.roomNumber} (${b.seat} ที่นั่ง)`,
  );
}

function calculateExamEventSummary(createAble: boolean[]) {
  const totalEvents = createAble.length;
  const creatableEvents = createAble.filter((isCreatable) => isCreatable).length;
  const nonCreatableEvents = totalEvents - creatableEvents;

  return {
    totalEvents,
    creatableEvents,
    nonCreatableEvents,
  };
}

export function mapperExamEventToReviewInfo(
  validateExamEventsData: boolean[],
  buildings: {
    buildingName: string;
    roomNumber: string;
    floor: string;
    roomNameTh: string;
    seat: number;
  }[],
  event?: RecurringExamEventCreationFormType | null,
) {
  const registrationRange = formatThaiDateRangeSameMonth(
    new Date(event?.examDateGroup?.examRecurringStartDate ?? ''),
    new Date(event?.examDateGroup?.examRecurringEndDate ?? ''),
    new Date(event?.examDateGroup?.startTime ?? ''),
    new Date(event?.examDateGroup?.endTime ?? ''),
  );
  const dateRange = mapExamDaysToThai(event?.examDateGroup?.date ?? []);

  return {
    registrationRange,
    dateRange,
    location: event?.location.locationName?.label ?? '-',
    buildings: getBuildingDisplayName(buildings),
    province: event?.location.province?.label ?? '-',
    proctor: event?.mainProctors?.length
      ? event.mainProctors.map((proctor) => proctor.label).join(', ')
      : '-',
    examStartTime: `เปิดรับสมัคร: ${formatThaiDateTime(event?.eventStartDate ?? new Date())}`,
    examEndTime: formatExamEndTime(event?.eventEndDate),
    summary: calculateExamEventSummary(validateExamEventsData),
  };
}
